import { Model as ORMModel, attr } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'

export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr(),
    }
  }
  static reducer(action, Mail, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_MAILS:
        session.Mail.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_MAILS:
        action?.payload?.forEach(newItem => {
          session.Mail.upsert(newItem)
        })
        break
      case Types.ADD_MAIL:
        const id = action?.payload?.id || getId()
        Mail.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_MAIL:
        item = Mail.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_MAIL:
        Mail.withId(action.payload.id).delete()
        break
      case Types.PRODUCTION_COMPLETE_MAIL:
        // find production
        // loop each match
        // generate random bool
        // if true, create a new mail from one of the sides
        // generate random index for message to be sent
        // do weights on the options so rare messages are sent rarely
        // consider conditionals around morale to decide on which options are available
        // mock data
        break
    }
  }
}
